import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { HomePage } from './home';

import { CalendarModule } from "ion2-calendar";

@NgModule({
  declarations: [
    HomePage
  ],
  imports: [
    CalendarModule,
    IonicPageModule.forChild(HomePage),
  ],
  exports: [
    HomePage
  ],
})
export class HomePageModule {}



// WEBPACK FOOTER //
// ./src/pages/home/home.module.ts